import { onAuthStateChanged } from 'firebase/auth';
import { useEffect } from 'react';
import { useMainStore } from '../../../core/store/mainStore';
import { auth } from '../../../firebaseConfig';

export const useHandleAuthState = () => {
  const setLoggedIn = useMainStore((state) => state.setLoggedIn);
  const setUserId = useMainStore((state) => state.setUserId);
  const setAuthReady = useMainStore((state) => state.setAuthReady);

  useEffect(() => {
    const sub = onAuthStateChanged(auth, (user) => {
      setLoggedIn(!!user);
      setUserId(user?.uid);
      setAuthReady(true);
    });
    return () => sub();
  }, [setLoggedIn, setUserId, setAuthReady]);
};
